import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';
import { Flip } from 'gsap/Flip';
import './Beginners.css';
import BegHome from '../Course/Beginners/pages/Home';
import Lenis from '@studio-freight/lenis'; // ✅ Static import
import SEO from '../SEO/SEO';
gsap.registerPlugin(ScrollTrigger, CustomEase, Flip);

function Begginers() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1,
      orientation: 'vertical',
      smoothWheel: true,
      smoothTouch: false,
      touchMultiplier: 1.5,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
      useOverscroll: true,
      useControls: true,
      useAnchor: true,
      useRaf: true,
      infinite: false
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }, []);

  return (
    <div className="App">
      <SEO
  title="Beginner English Course | Boldly English"
  description="Build your English confidence with beginner lessons, speaking practice, vocabulary, grammar, role play, and real-life conversations."
    canonical="https://boldlyenglish.com/beginners"
/>
      <div className="transition">
        <div className="transition-inner"></div>
      </div>
      <BegHome />
    </div>
  );
}

export default Begginers;
